import React from "react";
import "./Frame9.css";

function Frame9(props) {
  const { children } = props;

  return (
    <div className="frame-9-6">
      <div className="x3-etude-des-causes">{children}</div>
    </div>
  );
}

export default Frame9;
